export default __webpack_public_path__ + "static/media/set_4_Link-3.9cee8c71.svg";